export default __webpack_public_path__ + "comment-extractffa1db.svg";